import { Navigate } from "react-router-dom";
import { useOrganization } from "@/hooks/useOrganization";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Conditional route for /settings/setup.
 * - If org has completed setup → redirect to /settings
 * - If org hasn't completed setup → redirect to /onboarding
 */
export function SetupRoute() {
  const { organization, isLoading } = useOrganization();

  if (isLoading) {
    return (
      <div data-route-pending="true" className="flex items-center justify-center min-h-screen">
        <Skeleton className="h-12 w-48" />
      </div>
    );
  }

  // In older local schemas where setup_complete is not available, treat any existing
  // org as already configured to avoid forcing /onboarding.
  const hasSetupCompleteFlag = organization
    ? Object.prototype.hasOwnProperty.call(organization, "setup_complete")
    : false;

  if (!hasSetupCompleteFlag && organization && import.meta.env.DEV) {
    return <Navigate to="/settings/organization" replace />;
  }

  if (organization?.setup_complete) {
    return <Navigate to="/settings/organization" replace />;
  }

  if (organization === null) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Navigate to="/onboarding" replace />;
}
